// extracted by mini-css-extract-plugin
module.exports = {"container":"_3luGQOcn6mT0Qn0QyhISNc","visible":"_2VjGBYr5MVG7ErZ2xcalPV","cancelBtn":"_1VhK9F9GnZxqOp-VIAwWQH","icon":"_1Ft9If0B2s1QeWRiG9GD4V","saveBtn":"_2RIm3jHFHZJ1aLjNEv6f_n"};